import image04 from '../images/image04.png';
import image05 from '../images/image05.png';

export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-amber-800 mb-4">
            Sobre Nosotros
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-amber-600 to-transparent mx-auto"></div>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Text */}
          <div className="space-y-6">
            <h3 className="text-3xl font-semibold text-amber-700">
              Pasión por el Café de Especialidad
            </h3>
            <p className="text-lg text-stone-600 leading-relaxed">
              En <span className="font-semibold text-amber-700">arveta·house</span>, creemos que cada taza cuenta una historia. 
              Seleccionamos cuidadosamente nuestros granos de café de origen único y los tostamos 
              con precisión para resaltar sus notas naturales.
            </p>
            <p className="text-lg text-stone-600 leading-relaxed">
              Nuestro brunch combina ingredientes frescos y locales con técnicas culinarias innovadoras, 
              creando experiencias gastronómicas memorables que complementan perfectamente tu café favorito.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center gap-2 text-amber-700">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">Café de Especialidad</span>
              </div>
              <div className="flex items-center gap-2 text-amber-700">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">Ingredientes Frescos</span>
              </div>
              <div className="flex items-center gap-2 text-amber-700">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="font-medium">Ambiente Acogedor</span>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-200 to-rose-200 rounded-2xl blur-xl opacity-30"></div>
            <img
              src={image04}
              alt="Interior de arveta house"
              className="relative rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
          </div>
        </div>

        {/* Second Row - Reversed */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
          {/* Image */}
          <div className="relative order-2 md:order-1">
            <div className="absolute -inset-4 bg-gradient-to-r from-rose-200 to-amber-200 rounded-2xl blur-xl opacity-30"></div>
            <img
              src={image05}
              alt="Café y alimentos de arveta house"
              className="relative rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
          </div>

          {/* Text */}
          <div className="space-y-6 order-1 md:order-2">
            <h3 className="text-3xl font-semibold text-amber-700">
              Una Experiencia Completa
            </h3>
            <p className="text-lg text-stone-600 leading-relaxed">
              Más que una cafetería, somos un espacio donde la comunidad se reúne. 
              Ya sea para una reunión de trabajo, una conversación con amigos o un momento de tranquilidad, 
              encontrarás el ambiente perfecto.
            </p>
            <p className="text-lg text-stone-600 leading-relaxed">
              Nuestro equipo de baristas altamente capacitados está dedicado a crear 
              la experiencia perfecta en cada visita, desde el primer sorbo hasta el último bocado.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16 pt-16 border-t border-stone-200">
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-amber-600 to-amber-700 bg-clip-text text-transparent mb-2">
              5★
            </div>
            <div className="text-sm text-stone-600 font-medium">Calidad Premium</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-amber-600 to-amber-700 bg-clip-text text-transparent mb-2">
              100%
            </div>
            <div className="text-sm text-stone-600 font-medium">Ingredientes Frescos</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-amber-600 to-amber-700 bg-clip-text text-transparent mb-2">
              +50
            </div>
            <div className="text-sm text-stone-600 font-medium">Opciones en Menú</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold bg-gradient-to-r from-amber-600 to-amber-700 bg-clip-text text-transparent mb-2">
              ∞
            </div>
            <div className="text-sm text-stone-600 font-medium">Momentos Especiales</div>
          </div>
        </div>
      </div>
    </section>
  );
}
